var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
//!!!! WARNING !!!!!!!!
//This is an auto generated file.
//Changes to this code will be lost if the code is regenerated.
//Generated by: TsAppClientApiPrinter
//Contact #dev-ui-platform-support in case of issues
import { GeneratedApiClient } from "../ApiClient";
import { HttpMethod, AuthStrategy } from "../HttpClient";
/* tslint:disable:no-namespace */
export var VehicleMarketplaceService;
(function (VehicleMarketplaceService) {
    var ApiClientClass = /** @class */ (function (_super) {
        __extends(ApiClientClass, _super);
        function ApiClientClass() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            /** Generated from: {@link [FleetOwnerController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/controller/FleetOwnerController.ts)} */
            _this.vehicleListingGetListingWizardSteps = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/vehicle/listing/getListingWizardSteps",
                            service_id: "vehicle-marketplace",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/controller/FleetOwnerController.ts)} */
            _this.vehicleListingGet = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/vehicle/listing/get",
                            service_id: "vehicle-marketplace",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/controller/FleetOwnerController.ts)} */
            _this.vehicleListingCreate = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/vehicle/listing/create",
                            service_id: "vehicle-marketplace",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/controller/FleetOwnerController.ts)} */
            _this.vehicleListingUpdate = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/vehicle/listing/update",
                            service_id: "vehicle-marketplace",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/controller/FleetOwnerController.ts)} */
            _this.vehicleListingCopy = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/vehicle/listing/copy",
                            service_id: "vehicle-marketplace",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/controller/FleetOwnerController.ts)} */
            _this.vehicleListingValidateForm = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/vehicle/listing/validateForm",
                            service_id: "vehicle-marketplace",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/controller/FleetOwnerController.ts)} */
            _this.vehicleListingPublish = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/vehicle/listing/publish",
                            service_id: "vehicle-marketplace",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/controller/FleetOwnerController.ts)} */
            _this.vehicleListingDeactivate = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/vehicle/listing/deactivate",
                            service_id: "vehicle-marketplace",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/controller/FleetOwnerController.ts)} */
            _this.vehicleListingUploadImage = function (body, files, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/vehicle/listing/uploadImage",
                            service_id: "vehicle-marketplace",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body,
                            files: files
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/controller/FleetOwnerController.ts)} */
            _this.vehicleListingGetImageUrls = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/vehicle/listing/getImageUrls",
                            service_id: "vehicle-marketplace",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/controller/FleetOwnerController.ts)} */
            _this.vehicleListingRemoveImage = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/vehicle/listing/removeImage",
                            service_id: "vehicle-marketplace",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/controller/FleetOwnerController.ts)} */
            _this.vehicleListingSearch = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/vehicle/listing/search",
                            service_id: "vehicle-marketplace",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/controller/FleetOwnerController.ts)} */
            _this.vehicleApplicationAccept = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/vehicle/application/accept",
                            service_id: "vehicle-marketplace",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/controller/FleetOwnerController.ts)} */
            _this.vehicleApplicationGetDeclineReasons = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/vehicle/application/getDeclineReasons",
                            service_id: "vehicle-marketplace",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/controller/FleetOwnerController.ts)} */
            _this.vehicleApplicationDecline = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/vehicle/application/decline",
                            service_id: "vehicle-marketplace",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/controller/FleetOwnerController.ts)} */
            _this.vehicleApplicationSearch = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/vehicleApplication/search",
                            service_id: "vehicle-marketplace",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/controller/FleetOwnerController.ts)} */
            _this.vehicleApplicationGet = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/vehicle/application/get",
                            service_id: "vehicle-marketplace",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.JWT },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            return _this;
        }
        return ApiClientClass;
    }(GeneratedApiClient));
    // Split class actual prototype and type
    VehicleMarketplaceService.ApiClient = ApiClientClass;
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var Accessibility;
    (function (Accessibility) {
        Accessibility["VISIBLE"] = "visible";
        Accessibility["HIDDEN"] = "hidden";
    })(Accessibility = VehicleMarketplaceService.Accessibility || (VehicleMarketplaceService.Accessibility = {}));
    /** Generated from: {@link [ApplicationService.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/service/ApplicationService.ts)} */
    var ApplicationDeclineReason;
    (function (ApplicationDeclineReason) {
        ApplicationDeclineReason["DOES_NOT_SPEAK_LANGUAGE"] = "does_not_speak_language";
        ApplicationDeclineReason["DOES_NOT_KNOW_CITY_ENOUGH"] = "does_not_know_city_enough";
        ApplicationDeclineReason["DOES_NOT_HAVE_ENOUGH_EXPERIENCE"] = "does_not_have_enough_experience";
        ApplicationDeclineReason["DOCUMENTATION_PROBLEMS"] = "documentation_problems";
        ApplicationDeclineReason["LOCATION_INCOMPATIBLE"] = "location_incompatible";
        ApplicationDeclineReason["DOES_NOT_MEET_AGE_CRITERIA"] = "does_not_meet_age_criteria";
    })(ApplicationDeclineReason = VehicleMarketplaceService.ApplicationDeclineReason || (VehicleMarketplaceService.ApplicationDeclineReason = {}));
    /** Generated from: {@link [ApplicationTable.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/table/ApplicationTable.ts)} */
    var ApplicationStatus;
    (function (ApplicationStatus) {
        ApplicationStatus["DRAFT"] = "draft";
        ApplicationStatus["PUBLISHED"] = "published";
        ApplicationStatus["IN_PROGRESS"] = "in_progress";
        ApplicationStatus["REJECTED"] = "rejected";
        ApplicationStatus["INACTIVE"] = "inactive";
        ApplicationStatus["DECLINED"] = "declined";
        ApplicationStatus["APPROVED"] = "approved";
    })(ApplicationStatus = VehicleMarketplaceService.ApplicationStatus || (VehicleMarketplaceService.ApplicationStatus = {}));
    /** Generated from: {@link [BrandHelper.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/util/brand/BrandHelper.ts)} */
    var BrandEnum;
    (function (BrandEnum) {
        BrandEnum["BOLT"] = "bolt";
        BrandEnum["HOPP"] = "hopp";
    })(BrandEnum = VehicleMarketplaceService.BrandEnum || (VehicleMarketplaceService.BrandEnum = {}));
    /** Generated from: {@link [CarColorHelper.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/CarColorHelper.ts)} */
    var CarColor;
    (function (CarColor) {
        CarColor["White"] = "white";
        CarColor["Black"] = "black";
        CarColor["Blue"] = "blue";
        CarColor["Green"] = "green";
        CarColor["Yellow"] = "yellow";
        CarColor["Red"] = "red";
        CarColor["Purple"] = "purple";
        CarColor["Gray"] = "gray";
        CarColor["Brown"] = "brown";
        CarColor["Beige"] = "beige";
        CarColor["Pink"] = "pink";
        CarColor["Orange"] = "orange";
        CarColor["Gold"] = "gold";
        CarColor["Silver"] = "silver";
        CarColor["Bronze"] = "bronze";
        CarColor["Maroon"] = "maroon";
        CarColor["Wine"] = "wine";
        CarColor["WineRed"] = "wineRed";
        CarColor["SkyBlue"] = "skyBlue";
        CarColor["LightBlue"] = "lightBlue";
        CarColor["PearlWhite"] = "pearlWhite";
        CarColor["Pearl"] = "pearl";
        CarColor["DarkGrey"] = "darkGrey";
        CarColor["NavyBlue"] = "navyBlue";
    })(CarColor = VehicleMarketplaceService.CarColor || (VehicleMarketplaceService.CarColor = {}));
    /** Generated from: {@link [FleetCarInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/fleet/FleetCarInternalAsyncApi.ts)} */
    var CarModelBodyType;
    (function (CarModelBodyType) {
        CarModelBodyType["SEDAN"] = "sedan";
        CarModelBodyType["VAN"] = "van";
        CarModelBodyType["MINIVAN"] = "minivan";
        CarModelBodyType["WAGON"] = "wagon";
        CarModelBodyType["SUV"] = "suv";
        CarModelBodyType["HATCHBACK"] = "hatchback";
        CarModelBodyType["RICKSHAW"] = "rickshaw";
        CarModelBodyType["MOTORBIKE"] = "motorbike";
    })(CarModelBodyType = VehicleMarketplaceService.CarModelBodyType || (VehicleMarketplaceService.CarModelBodyType = {}));
    /** Generated from: {@link [FormTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/FormTypes.ts)} */
    var ComboBoxAppearance;
    (function (ComboBoxAppearance) {
        ComboBoxAppearance["HEADER_INACTIVE"] = "header_inactive";
        ComboBoxAppearance["COLUMN_SPLIT"] = "column_split";
    })(ComboBoxAppearance = VehicleMarketplaceService.ComboBoxAppearance || (VehicleMarketplaceService.ComboBoxAppearance = {}));
    /** Generated from: {@link [FormTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/FormTypes.ts)} */
    var CustomIcon;
    (function (CustomIcon) {
        CustomIcon["BRIEFCASE"] = "briefcase";
        CustomIcon["BUSINESS_RIDE"] = "business_ride";
    })(CustomIcon = VehicleMarketplaceService.CustomIcon || (VehicleMarketplaceService.CustomIcon = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var DateType;
    (function (DateType) {
        DateType["DATETIME"] = "datetime";
        DateType["SHORT_DATETIME"] = "short_datetime";
    })(DateType = VehicleMarketplaceService.DateType || (VehicleMarketplaceService.DateType = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var EntityState;
    (function (EntityState) {
        EntityState["DEFAULT"] = "default";
        EntityState["INACTIVE"] = "inactive";
        EntityState["ALERT"] = "alert";
        EntityState["SUCCESS"] = "success";
        EntityState["DANGER"] = "danger";
        EntityState["WARNING"] = "warning";
        EntityState["PENDING"] = "pending";
    })(EntityState = VehicleMarketplaceService.EntityState || (VehicleMarketplaceService.EntityState = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var EnumKey;
    (function (EnumKey) {
        EnumKey["CREATED_BY_FLEET"] = "created_by_fleet";
        EnumKey["CREATED_BY_RIDER"] = "created_by_rider";
        EnumKey["CASH"] = "cash";
        EnumKey["CARD_TERMINAL"] = "card_terminal";
        EnumKey["IN_APP"] = "in_app";
        EnumKey["BUSINESS"] = "business";
    })(EnumKey = VehicleMarketplaceService.EnumKey || (VehicleMarketplaceService.EnumKey = {}));
    /** Generated from: {@link [FormTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/FormTypes.ts)} */
    var FieldName;
    (function (FieldName) {
        FieldName["COMPANY_NAME"] = "company_name";
        FieldName["FLEET_SIZE"] = "fleet_size";
        FieldName["CITY_ID"] = "city_id";
        FieldName["BILLING_TYPE"] = "billing_type";
        FieldName["PAYOUT_RECIPIENT_TYPE"] = "payout_recipient_type";
        FieldName["ADDRESS"] = "address";
        FieldName["REG_CODE"] = "reg_code";
        FieldName["IS_LIABLE_TO_VAT"] = "is_liable_to_vat";
        FieldName["VAT_CODE"] = "vat_code";
        FieldName["ACCOUNT_RECIPIENT"] = "account_recipient";
        FieldName["ACCOUNT_IBAN"] = "account_iban";
        FieldName["ACCOUNT_SWIFT"] = "account_swift";
        FieldName["TAX_IDENTIFICATION_NUMBER"] = "tax_identification_number";
        FieldName["TAX_IDENTIFICATION_NUMBER_COUNTRY"] = "tax_identification_number_country";
        FieldName["NEW_PASSWORD"] = "new_password";
        FieldName["CURRENT_PASSWORD"] = "current_password";
        FieldName["PHONE_NUMBER"] = "phone_number";
        FieldName["PHONE_COUNTRY_CODE"] = "phone_country_code";
        FieldName["EMAIL"] = "email";
        FieldName["EMAIL_OR_USERNAME"] = "email_or_username";
        FieldName["FIRST_NAME"] = "first_name";
        FieldName["LAST_NAME"] = "last_name";
    })(FieldName = VehicleMarketplaceService.FieldName || (VehicleMarketplaceService.FieldName = {}));
    /** Generated from: {@link [FormTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/FormTypes.ts)} */
    var FormFieldType;
    (function (FormFieldType) {
        FormFieldType["TEXT"] = "text_input";
        FormFieldType["NUMBER"] = "number_input";
        FormFieldType["COMBOBOX"] = "combo_box";
        FormFieldType["CHECKBOX"] = "check_box";
        FormFieldType["CHECKBOXGROUP"] = "check_box_group";
        FormFieldType["RADIOGROUP"] = "radio_group";
        FormFieldType["FILEUPLOAD"] = "file_upload";
        FormFieldType["IMAGEUPLOAD"] = "image_upload";
        FormFieldType["PASSWORD"] = "password";
        FormFieldType["EMAIL"] = "email";
        FormFieldType["INFOTEXT"] = "info_text";
        FormFieldType["INFOTEXTGROUP"] = "info_text_group";
    })(FormFieldType = VehicleMarketplaceService.FormFieldType || (VehicleMarketplaceService.FormFieldType = {}));
    /** Generated from: {@link [FormTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/FormTypes.ts)} */
    var IconType;
    (function (IconType) {
        IconType["KALEP"] = "kalep";
        IconType["REACT_FLAGS"] = "react_flags";
        IconType["CUSTOM"] = "custom";
    })(IconType = VehicleMarketplaceService.IconType || (VehicleMarketplaceService.IconType = {}));
    /** Generated from: {@link [ListingTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/constants/ListingTypes.ts)} */
    var Insurance;
    (function (Insurance) {
        Insurance["YES"] = "yes";
        Insurance["NO"] = "no";
    })(Insurance = VehicleMarketplaceService.Insurance || (VehicleMarketplaceService.Insurance = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var ListColumnType;
    (function (ListColumnType) {
        ListColumnType["STRING"] = "string";
        ListColumnType["DURATION"] = "duration";
        ListColumnType["NUMBER"] = "number";
        ListColumnType["REFERENCE_V2"] = "reference_v2";
        ListColumnType["STATE"] = "state";
        ListColumnType["DATE"] = "date";
        ListColumnType["BOOLEAN"] = "boolean";
        ListColumnType["STATUS"] = "status";
        ListColumnType["ENUM"] = "enum";
        ListColumnType["CUSTOM"] = "custom";
    })(ListColumnType = VehicleMarketplaceService.ListColumnType || (VehicleMarketplaceService.ListColumnType = {}));
    /** Generated from: {@link [ListingTable.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/table/ListingTable.ts)} */
    var ListingStatus;
    (function (ListingStatus) {
        ListingStatus["DRAFT"] = "draft";
        ListingStatus["PUBLISHED"] = "published";
        ListingStatus["INACTIVE"] = "inactive";
    })(ListingStatus = VehicleMarketplaceService.ListingStatus || (VehicleMarketplaceService.ListingStatus = {}));
    /** Generated from: {@link [WizardTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/constants/WizardTypes.ts)} */
    var ListingStepId;
    (function (ListingStepId) {
        ListingStepId["CONDITION_MILEAGE"] = "condition_mileage";
        ListingStepId["PRICING"] = "pricing";
        ListingStepId["PHOTOS"] = "photos";
        ListingStepId["DRIVER_REQUIREMENTS"] = "driver_requirements";
    })(ListingStepId = VehicleMarketplaceService.ListingStepId || (VehicleMarketplaceService.ListingStepId = {}));
    /** Generated from: {@link [ListingTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/constants/ListingTypes.ts)} */
    var Maintenance;
    (function (Maintenance) {
        Maintenance["YES"] = "yes";
        Maintenance["NO"] = "no";
    })(Maintenance = VehicleMarketplaceService.Maintenance || (VehicleMarketplaceService.Maintenance = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var NumberType;
    (function (NumberType) {
        NumberType["INTEGER"] = "integer";
        NumberType["DECIMAL"] = "decimal";
    })(NumberType = VehicleMarketplaceService.NumberType || (VehicleMarketplaceService.NumberType = {}));
    /** Generated from: {@link [ListingTable.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/table/ListingTable.ts)} */
    var OfferPeriod;
    (function (OfferPeriod) {
        OfferPeriod["DAILY"] = "daily";
        OfferPeriod["WEEKLY"] = "weekly";
        OfferPeriod["MONTHLY"] = "monthly";
    })(OfferPeriod = VehicleMarketplaceService.OfferPeriod || (VehicleMarketplaceService.OfferPeriod = {}));
    /** Generated from: {@link [ListingTable.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/table/ListingTable.ts)} */
    var OfferType;
    (function (OfferType) {
        OfferType["RENT"] = "rent";
        OfferType["RENT_TO_BUY"] = "rent_to_buy";
    })(OfferType = VehicleMarketplaceService.OfferType || (VehicleMarketplaceService.OfferType = {}));
    /** Generated from: {@link [FormTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/FormTypes.ts)} */
    var PasswordValidationType;
    (function (PasswordValidationType) {
        PasswordValidationType["PASSWORD_LENGTH"] = "password_length";
        PasswordValidationType["CONTAIN_UPPER_AND_LOWER_CASE_LETTERS"] = "contain_upper_and_lower_case_letters";
        PasswordValidationType["CONTAIN_NUMBERS"] = "contain_numbers";
    })(PasswordValidationType = VehicleMarketplaceService.PasswordValidationType || (VehicleMarketplaceService.PasswordValidationType = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var ReferenceType;
    (function (ReferenceType) {
        ReferenceType["VEHICLE"] = "vehicle";
        ReferenceType["DRIVER"] = "driver";
        ReferenceType["VEHICLE_LISTING_APPLICATION"] = "vehicle_listing_application";
    })(ReferenceType = VehicleMarketplaceService.ReferenceType || (VehicleMarketplaceService.ReferenceType = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var TrendBehavior;
    (function (TrendBehavior) {
        TrendBehavior["POSITIVE_IS_SUCCESS"] = "positive_as_success";
        TrendBehavior["POSITIVE_IS_DANGER"] = "positive_as_danger";
    })(TrendBehavior = VehicleMarketplaceService.TrendBehavior || (VehicleMarketplaceService.TrendBehavior = {}));
    /** Generated from: {@link [ListingTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/constants/ListingTypes.ts)} */
    var VehicleCondition;
    (function (VehicleCondition) {
        VehicleCondition["EXCELLENT"] = "condition_excellent";
        VehicleCondition["GOOD"] = "condition_good";
        VehicleCondition["FAIR"] = "condition_fair";
    })(VehicleCondition = VehicleMarketplaceService.VehicleCondition || (VehicleMarketplaceService.VehicleCondition = {}));
    /** Generated from: {@link [ListingTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/constants/ListingTypes.ts)} */
    var VehicleFuelType;
    (function (VehicleFuelType) {
        VehicleFuelType["DIESEL"] = "fuel_type_diesel";
        VehicleFuelType["ELECTRIC"] = "fuel_type_electric";
        /**
         * @deprecated Replaced with FUEL_TYPE_GASOLINE_AND_ELECTRIC. Left in to support value in older listings
         */
        VehicleFuelType["HYBRID"] = "fuel_type_hybrid";
        VehicleFuelType["PETROL"] = "fuel_type_petrol";
        VehicleFuelType["GASOLINE_AND_ELECTRIC"] = "fuel_type_gasoline_and_electric";
        VehicleFuelType["GASOLINE_AND_LPG"] = "fuel_type_gasoline_and_lpg";
        VehicleFuelType["GASOLINE_AND_CNG"] = "fuel_type_gasoline_and_cng";
    })(VehicleFuelType = VehicleMarketplaceService.VehicleFuelType || (VehicleMarketplaceService.VehicleFuelType = {}));
    /** Generated from: {@link [ListingTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/constants/ListingTypes.ts)} */
    var VehicleGearbox;
    (function (VehicleGearbox) {
        VehicleGearbox["AUTOMATIC"] = "gearbox_automatic";
        VehicleGearbox["MANUAL"] = "gearbox_manual";
    })(VehicleGearbox = VehicleMarketplaceService.VehicleGearbox || (VehicleMarketplaceService.VehicleGearbox = {}));
    /** Generated from: {@link [ListingTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/vehicle/vehicle_marketplace/main/constants/ListingTypes.ts)} */
    var VehicleMileage;
    (function (VehicleMileage) {
        VehicleMileage["UP_TO_20K"] = "mileage_up_to_20k";
        VehicleMileage["FROM_20K_TO_50K"] = "mileage_from_20k_to_50k";
        VehicleMileage["FROM_50K_TO_100K"] = "mileage_from_50k_to_100k";
        VehicleMileage["FROM_100K_TO_200K"] = "mileage_from_100k_to_200k";
        VehicleMileage["MORE_THAN_200K"] = "mileage_more_than_200k";
    })(VehicleMileage = VehicleMarketplaceService.VehicleMileage || (VehicleMarketplaceService.VehicleMileage = {}));
})(VehicleMarketplaceService || (VehicleMarketplaceService = {}));
